var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "certificate-index" } },
    [
      _c(
        "Titlebar",
        {
          scopedSlots: _vm._u([
            {
              key: "incrustation",
              fn: function () {
                return [_c("IconCertificate")]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" "), _c("h1", [_vm._v(_vm._s(_vm.$t("nav.certificate")))])]
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.isLoading
              ? _c(
                  "div",
                  {
                    staticClass: "spinner-border text-secondary mt-3",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("global.loading"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoading
              ? _c(
                  "UiCard",
                  { staticStyle: { "border-radius": "2px !important" } },
                  [_c("div", { domProps: { innerHTML: _vm._s(_vm.html) } })]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c(
            "Btn",
            {
              staticClass: "pull-right primary",
              class: { disabled: _vm.isDownloadLoading },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.downloadReport($event)
                },
              },
            },
            [
              _vm.isDownloadLoading
                ? _c("div", {
                    staticClass: "spinner-border spinner-border-sm",
                    attrs: { role: "status" },
                  })
                : _vm._e(),
              _vm._v("\n      " + _vm._s(_vm.$t("global.download")) + "\n    "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }